
import barba from '@barba/core';
// import SmoothScroll from "smooth-scroll";
import { gsap } from 'gsap/dist/gsap'
import { ScrollToPlugin } from 'gsap/dist/ScrollToPlugin'
gsap.registerPlugin(ScrollToPlugin)


/**
 * #から始まるリンクをクリックした際にスムーススクロールを有効にする
 * リンクに[data-scroll-ignore]を付与すると無効になる
 * [data-header]を付与した要素の高さ分ずらすことが可能
 * initailScrollで初期読み込み時、Pjax遷移時にアンカーリンクの箇所まで移動する
 */
export default class{

	constructor(){
        // this.running = false
		// this.SmoothScroll;
        // this.options = {
        //     ignore: '[data-scroll-ignore]',
        //     header: '[data-header]',
        //     speed: 500,
        //     offset: 0,
        //     easing: 'easeInOutCubic',
        //     updateURL: false,
        // };
        
        barba.hooks.afterOnce((data) => {
            this.scroll();
        })
        
       
        barba.hooks.after((data) => {
            this.scroll();
        });
    }
    scroll(){
        
        const smoothScrollWithoutHash = (selector) => {
            
            const clickHandler =  (event) => {
                
                let toggle = selector
                if ( !toggle || toggle.tagName.toLowerCase() !== 'a' ) return;
                let site_url = window.location.protocol + '//' + window.location.host;
                if (!toggle.href.startsWith(site_url)) {
                    return;
                }
                let digit = toggle.hash.replace(/^#/,"");
                let anchor = document.getElementById( digit );

                if ( !anchor ) return;
                if(toggle.getAttribute('data-scroll-ignore'))
                    return;

                let url = location.protocol + '//' + location.host + location.pathname;
                let extract_hash = toggle.href.replace(/#.*$/,"");
                if (url !== extract_hash) {
                    return;
                }
                event.preventDefault();
                // if( this.running ){
                //     this.SmoothScroll.cancelScroll();
                //     return false;
                // }
                
                const header = document.querySelector('[data-header]')
                let headerHeight
                if(header){
                    headerHeight = header.clientHeight
                }
                // this.ua = window.navigator.userAgent.toLowerCase();
                // if(this.ua.indexOf("windows nt") !== -1) {

                //     const wrapper = document.querySelector('#wrapper')
                    
                //     if(wrapper){
                //         gsap.to(wrapper, {duration: .5, scrollTo:{ y: "#" + digit, offsetY:headerHeight, ease: "power2"}})
                //     }
                // }else{
                    gsap.to(window, {duration: .5, scrollTo:{ y: "#" + digit, offsetY:headerHeight, ease: "power2"}})
                // }
            };

            
            selector.addEventListener('click', clickHandler, false );
        };
        const links = document.querySelectorAll('a[href*="#"]');
        if(links.length > 0){
            links.forEach( (link,i) => {
                smoothScrollWithoutHash( links[i] );
            })
            
        }
        
    }
    
}